import { TicketConfigContextValue } from "./types";

export const initialTicketConfigContextValue: TicketConfigContextValue = {
    loading: true,
    error: null,
    config: {} as any,
    tableColumns: []
};